<template lang="pug">
div.field-format
    el-form(label-position="top")
        el-form-item(:label="fieldLabel")
            el-input(v-model="customFormat", style="width:90%", ref="customFormatInput", @change="changeDBFormat")
            el-select(v-model="chunkPicker", style="width:10%", @change="changeChunk")
                el-option(label="+", value="+")
                el-option(v-for="(field, j) in Object.keys(fieldNames)" :key="field" :value="field" :label="`${fieldNames[field].label} (${field})`")
</template>
<script>
import _ from "lodash";
import gql from "graphql-tag";

export default {
    props: {
        fieldLabel: String,
        fieldNames: Object,
        settingKey: String,
        value: String,
        type: String,
        persistedFormat: String,
    },
    data() {
        return {
            customFormat: "",
            chunkPicker: "+",
            dbFormat: "",
            original: ""
        };
    },

    watch: {
        dbFormat() {
            this.updateModel();
        },
        value(val) {
            this.original = val;
            this.customFormat = this.convertToDisplayFormat();
        }
    },
    computed: {
        fieldMapping() {
            let fields = {};

            Object.keys(this.fieldNames).forEach(function(key) {
                fields[this.fieldNames[key].value] = key;
            }, this);
            
            return fields;
        }
    },
    apollo: {
        settings: {
            query: gql`
                    query Settings($type: SettingsTypeEnum!) {
                        Settings(type: $type) {
                            id
                            course_id_format
                            course_name_format
                            location_id_format
                            location_name_format
                            class_id_format
                            custom_value
                            roster_id_format
                            department_student
                            department_employee
                            office_location_employee
                            office_location_student
                            job_title
                            employee_type
                            calendar_lesson_title_employee
                            calendar_lesson_description_employee
                            calendar_lesson_location_employee
                            calendar_lesson_title_student
                            calendar_lesson_description_student
                            calendar_lesson_location_student
                            student_id_field
                            employee_id_field
                        }
                }
            `,
            variables() {
                return {
                    type: this.type || "school"
                }
            },
            update(r) {
                this.original = r.Settings[`${this.settingKey}`];
                this.customFormat = this.convertToDisplayFormat();
                this.changeDBFormat();
                this.updateModel();
            },
            fetchPolicy: "no-cache",
        },
    },

    methods: {
        getUid() {
            return Math.floor(Math.random() * 100000);
        },

        getRandom(arr) {
            return arr[Math.floor(Math.random() * (arr.length - 1))];
        },

        changeChunk() {
            const customFormatInput = this.$refs.customFormatInput.$refs.input
            let start = customFormatInput.selectionStart;
            let end = customFormatInput.selectionEnd;
            const customFormatValue = Object.assign(this.customFormat);
            const chunkPickerValue = Object.assign(this.chunkPicker);
            this.customFormat = `${customFormatValue.slice(0, start)}{${chunkPickerValue}}${customFormatValue.slice(end)}`;
            start = end = start + `{${chunkPickerValue}}`.length;
            this.changeDBFormat();
            this.chunkPicker = "+";
            this.updateModel();
        },

        changeDBFormat() {
            const chunks = this.getFormat().split(/(\{.*?\})/);
            this.dbFormat = _(chunks)
                .filter((chunk) => {
                    return !_.isEmpty(chunk);
                })
                .map((chunk) => {
                    const key = chunk.replaceAll(/\{|\}/g, "");
                    return this.fieldNames[key] ? `${this.fieldNames[key].value}` : `'${chunk.replaceAll(/\'/g, "\\'")}'`;
                })
                .value()
                .join(" + ");
            this.updateModel();
        },

        convertToDisplayFormat() {
            if (this.persistedFormat !== undefined) {
                this.original = this.persistedFormat;
            }

            if (this.original === undefined || this.original === null) return "";
            
            const chunks = this.original.split(" + ");
            return _(chunks).map((chunk) => {
                return this.fieldMapping[chunk] ? `{${this.fieldMapping[chunk]}}` : chunk.replaceAll(/(?<!\\)'/g, "").replaceAll(/\\'/g, "'");
            })
            .value()
            .join("");
        },

        updateModel() {
            this.$emit("input", this.dbFormat);
        },

        getFormat() {
            return this.customFormat;
        },
    },

    watch: {
        persistedFormat() {
            this.customFormat = this.convertToDisplayFormat();
            this.changeDBFormat();
        }
    }
};
</script>

